<template>
    <div style="min-width: 100%">
        <ConfigAPI2
            :companyId="companyId"
            :inProfileId="
                company && company.profile && company.profile.id ? company.profile.id : ''
            "
            :mode="'Accounting'"
        />
        <!-- <ConfigAPI
            :companyId="companyId"
            :profileId="company && company.profile && company.profile.id ? company.profile.id : ''"
            :mode="'Accounting'"
        ></ConfigAPI> -->
    </div>
</template>

<script lang="ts">
import gql from "graphql-tag";
import { Apollo } from "@/decorators";
import ConfigAPI2 from "./ConfigAPI2.vue";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

@Component({
    components: {
        ConfigAPI2,
    },
})
export class ConfigAPIPage extends Vue {
    @Prop({ default: "" }) companyId: string;

    @Apollo({
        query: gql`
            query companyDetails($id: ID!) {
                company(where: { id: $id }) {
                    id
                    profile {
                        id
                    }
                }
            }
        `,
        variables() {
            return {
                id: this.companyId,
            };
        },
        skip() {
            return !this.companyId;
        },
        specificResult({ data, loading, networkStatus }: any) {
            this.loadingDocument = loading;
            if (!loading) {
                if (data && data.company) {
                    this.company = data.company;
                }
            }
        },
    })
    company = {
        profile: null,
    };
}

export default toNative(ConfigAPIPage);
</script>

<style></style>
